/*
 * curried function that accepts a set of formik-injected properties
 * returns a function that accepts an identifier string and
 * returns an object that has the formik-props mapped to the props
 * a material-ui TextField expects to receive
 * */

const mapFormikToMuiProps = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
}) => identifier => {
  const errorMessage = touched[identifier] && errors[identifier]

  const name = identifier
  const label = identifier
  const value = values[identifier]

  /* default to empty string otherwise this value will be false (boolean) */
  const helperText = errorMessage || ''

  /*
    cast to boolean because material-ui's TextField fails
    prop-types validation if 'error' isn't boolean
  */
  const error = Boolean(errorMessage)
  const onChange = handleChange
  const onBlur = handleBlur

  return {
    name,
    label,
    value,
    error,
    helperText,
    onChange,
    onBlur,
  }
}

export default mapFormikToMuiProps



// WEBPACK FOOTER //
// ./src/components/forms/form-utils/map-formik-to-mui-props.ts